import { dateToDateString } from '@jwplayer/fe-common/module/format/date';
import { addDays } from 'date-fns';

export const FIELDS_VALUES_KEYS = {
  MEDIA_LOGO_SHOW: 'MediaLogoShow',
  LOGO_URL: 'LogoUrl',
  PRIMARY_FONT: 'PrimaryFont',
  SECONDARY_FONT: 'SecondaryFont',
  MEDIA_STYLE: 'MediaStyle',
  LANGUAGE_DIRECTION: 'LanguageDirection',
  PUBLISH_DATE_LABEL: 'PublishDateLabel',
  AUTHOR_LABEL: 'AuthorLabel',
} as const;

export const MANDATORY_FIELD_NAMES = {
  TITLE: 'Title',
  IMAGE_URL: 'ImageUrl',
  CLICK_URL: 'ClickUrl',
  VIDEO_URL: 'VideoUrl',
};

export const ADDITIONAL_FIELDS_MAP_KEYS = {
  MediaTitleShow: 'MediaTitleShow',
  MediaPublishDateShow: 'MediaPublishDateShow',
  MediaAuthorNameShow: 'MediaAuthorNameShow',
  DescriptionShow: 'DescriptionShow',
  MediaAccentBarShow: 'MediaAccentBarShow',
};

export const ADDITIONAL_FIELDS_DEFAULT = [
  ADDITIONAL_FIELDS_MAP_KEYS.MediaTitleShow,
  ADDITIONAL_FIELDS_MAP_KEYS.MediaPublishDateShow,
  ADDITIONAL_FIELDS_MAP_KEYS.MediaAuthorNameShow,
  ADDITIONAL_FIELDS_MAP_KEYS.DescriptionShow,
  ADDITIONAL_FIELDS_MAP_KEYS.MediaAccentBarShow,
];

export const DISCOVERY_CONTENT_TYPE = {
  ARTICLE: 'ARTICLE',
  MEDIA: 'MEDIA',
};

export const DEFAULT_MEDIA_STYLE_JSON = {
  textContainer: {
    top: 'initial',
    left: '92px',
    bottom: '95px',
    right: 'initial',
  },
  title: {
    fontStyle: 'normal',
    fontSize: '73px',
    textAlign: 'left',
    background: 'white',
    color: 'black',
    height: 'fit-content',
    width: '1200px',
    lineClamp: '3',
  },
  publishDate: {
    fontStyle: 'normal',
    fontSize: '47.5px',
    textAlign: 'left',
    background: 'white',
    color: 'black',
    height: 'fit-content',
    width: 'fit-content',
  },
  author: {
    fontStyle: 'normal',
    fontSize: '47.5px',
    textAlign: 'left',
    background: 'white',
    color: 'black',
    height: 'fit-content',
    width: 'fit-content',
  },
  description: {
    fontStyle: 'normal',
    fontSize: '64px',
    textAlign: 'left',
    background: 'none',
    color: '#fff',
    left: '43px',
    top: '644px',
    bottom: 'initial',
    right: 'initial',
    height: '650px',
    width: '1050px',
  },
};

export const DEFAULT_MEDIA_SETTING_JSON = {
  LanguageDirection: null,
  PublishDateLabel: null,
  AuthorLabel: null,
};

export const DISCOVERY_DEFAULTS = {
  IS_ACTIVE: true,
  ACCENT_COLOR: '#0099FF',
  REFRESH_TIME_UNIT: 'DAY' as const,
  REFRESH_EVERY: 1,
  START_DATE: dateToDateString(addDays(new Date(), 1)),
  CHAPTER_ORDER: 'FEED_ORDER' as const,
  CHAPTER_DURATION: 18,
  CHAPTER_COUNT: 12,
  CUSTOM_HEADERS: [{ key: '', value: '' }],
  CONTENT_TYPE: 'ARTICLE' as const,
  USE_DIFFERENT_COLOR: false,
  CTA: {
    enabled: true,
    text: 'Read more',
    textColor: '#ffffff',
    backgroundColor: '#0099FF',
    useTemplateColor: true,
  },
  PRIMARY_FONT: '5b665868-beaa-4755-95f4-7ed499519d96',
  SECONDARY_FONT: 'f526edd9-6eb5-451e-8c87-0daf56d3871a',
  MEDIA_CUSTOM_SETTINGS: {
    LanguageDirection: null,
    PublishDateLabel: null,
    AuthorLabel: null,
  },
  MEDIA_STYLE: JSON.stringify(DEFAULT_MEDIA_STYLE_JSON, null, 2),
  REQUESTED_FIELDS: {
    useDefaultMapping: true,
    fields: [
      {
        name: 'Title',
        isMandatory: true,
      },
      {
        name: 'ImageUrl',
        isMandatory: true,
      },
      {
        name: 'ClickUrl',
        isMandatory: true,
      },
      {
        name: 'VideoUrl',
        isMandatory: true,
      },
      {
        name: 'Description',
        isMandatory: false,
      },
      {
        name: 'Keywords',
        isMandatory: false,
      },
      {
        name: 'PublishDate',
        isMandatory: false,
      },
      {
        name: 'Author',
        isMandatory: false,
      },
      {
        name: 'Language',
        isMandatory: false,
      },
    ],
  },
};

export const DISCOVERY_TYPE = ['discovery'];

export interface ActionResponse {
  message: string;
  success: boolean;
}
